import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';

/**
 * 메가메뉴 컬럼 수 제어 컴포넌트
 * 원본: mega-menu-columns-control.html
 */
const MegaMenuColumnsControl = () => {
  const { themeConfig, set } = useTheme();
  const currentThemeConfig = themeConfig || {};
  const navLayout = currentThemeConfig.navLayout || 'top';

  if (navLayout !== 'top') return null;

  return (
    <div id="mega-menu-columns-control-section" style={{ marginBottom: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}>
          <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>📋 메가메뉴 하위항목 컬럼 수:</label>
          <button
            type="button"
            className="theme-help-btn"
            data-target="mega-menu-columns-control-section"
            title="이 항목으로 이동"
            style={{
              background: 'transparent',
              border: '1px solid #ddd',
              color: '#666',
              fontSize: '11px',
              width: '20px',
              height: '20px',
              padding: 0,
              borderRadius: '50%',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f5f5f5';
              e.target.style.borderColor = 'var(--theme-color-primary)';
              e.target.style.color = 'var(--theme-color-primary)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#ddd';
              e.target.style.color = '#666';
            }}
          >
            ?
          </button>
        </div>
        <button
          type="button"
          onClick={() => set('megaMenuColumns', 1)}
          style={{
            background: 'transparent',
            border: '1px solid #ddd',
            color: '#666',
            fontSize: '11px',
            padding: '4px 10px',
            borderRadius: '3px',
            cursor: 'pointer'
          }}
        >
          리셋
        </button>
      </div>
      <div style={{ fontSize: '11px', color: '#999', marginBottom: '10px', lineHeight: 1.4 }}>
        메가메뉴 항목이 표시되는 컬럼 수를 설정합니다. (기본값: 1컬럼, 최대: 3컬럼)
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '12px', color: '#666', whiteSpace: 'nowrap' }}>컬럼 수:</span>
        <input
          type="number"
          value={currentThemeConfig.megaMenuColumns || 1}
          onChange={(e) => {
            const value = parseInt(e.target.value);
            if (!isNaN(value) && value >= 1 && value <= 3) {
              set('megaMenuColumns', value);
            }
          }}
          onBlur={(e) => {
            const value = parseInt(e.target.value);
            if (isNaN(value) || value < 1 || value > 3) {
              e.target.value = currentThemeConfig.megaMenuColumns || 1;
            }
          }}
          style={{
            width: '60px',
            padding: '6px 10px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '13px',
            fontFamily: 'monospace',
            textAlign: 'center'
          }}
          min="1"
          max="3"
        />
        <span style={{ fontSize: '12px', color: '#666' }}>컬럼</span>
      </div>
    </div>
  );
};

export default MegaMenuColumnsControl;

